export const kids = [
  {
    id: 1,
    img: "https://www.fulldronesolutions.com/wp-content/uploads/2020/09/Artikel-2-Pict-1.jpg",
    title: "DRONES AND SPORTS MEDIA: AN INTE-RVIEW WITH SKIP WHITMAN",
    author: "by Davide Hostines",
    date: "July 8, 2021",
    color: "#a0a0a0e1",
  },
  {
    id: 2,
    img: "https://www.techhog.com/wp-content/uploads/2020/07/Best-drones-for-kids.jpg",
    title: "DRONES AND SPORTS MEDIA: AN INTE-RVIEW WITH SKIP WHITMAN",
    author: "by Davide Hostines",
    date: "July 8, 2021",
    color: "#f6c14ddf",
  },
  {
    id: 3,
    img: "https://www.fulldronesolutions.com/wp-content/uploads/2020/09/Artikel-2-Pict-1.jpg",
    title: "DRONES AND SPORTS MEDIA: AN INTE-RVIEW WITH SKIP WHITMAN",
    author: "by Davide Hostines",
    date: "July 8, 2021",
    color: "#a0a0a0e1",
  },
  {
    id: 4,
    img: "https://www.fulldronesolutions.com/wp-content/uploads/2020/09/Artikel-2-Pict-1.jpg",
    title: "DRONES AND SPORTS MEDIA: AN INTE-RVIEW WITH SKIP WHITMAN",
    author: "by Davide Hostines",
    date: "July 8, 2021",
    color: "#a0a0a0e1",
  },
  {
    id: 5,
    img: "https://www.fulldronesolutions.com/wp-content/uploads/2020/09/Artikel-2-Pict-1.jpg",
    title: "DRONES AND SPORTS MEDIA: AN INTE-RVIEW WITH SKIP WHITMAN",
    author: "by Davide Hostines",
    date: "July 8, 2021",
    color: "#a0a0a0e1",
  },
  {
    id: 6,
    img: "https://www.fulldronesolutions.com/wp-content/uploads/2020/09/Artikel-2-Pict-1.jpg",
    title: "DRONES AND SPORTS MEDIA: AN INTE-RVIEW WITH SKIP WHITMAN",
    author: "by Davide Hostines",
    date: "July 8, 2021",
    color: "#a0a0a0e1",
  },
];